import api from '@/api';

const {  $core , $billing, $pricing } = api;
const $st = api.$student
export const { $billingData ,$student, $work } = $st ;
export const { $users} = $core;
export const { $receipt, $generatenc} = $billing;
export const { $prices } = $pricing;
